import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { pageDetails } from '../Recoil/ActiveEvents';

const Events = () => {

    const [responseData, setResponseData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currEid, setCurrEid] = useRecoilState(pageDetails);
    useEffect(() => {
      let eventURI = process.env.REACT_APP_API_URL +"/Events/GetCompletedEvents";
      fetch(eventURI , {method: "GET"})
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          let events = !!data.EventsType ? data.EventsType : []
          setResponseData(events);
          setLoading(false);
        })
        .catch(error => {
          setError(error.message);
          setLoading(false);
        });
    }, []);
    
    const setEventId = (item) => {
      setCurrEid({...currEid, selectedEID:item})
    }
  return <div >
        <div className='pt-30 bg-sandel-bg py-12'>
            <div className='max-w-[1024px] mx-auto px-4'>
                <h1 className='text-headerTitle text-h-1 font-bold'>Events</h1>
                <p className='text-bodyText text-t-18 py-4'>We’re proud of the events we’ve hosted that have made a lasting impact on our community. From charity fundraisers to awareness campaigns, each event has brought people together to support important causes and create meaningful change.</p>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-3 gap-4 mt-4'>
                  {responseData.map((item, index) => (
                      <div className="items-center bg-white rounded-lg drop-shadow-sm" key={index}>
                        <div className="w-full max-w-sm mx-auto">
                          <img  className="w-full h-auto object-contain object-cover rounded-t-lg min-h-32" src={item.ImgUrl} alt="Image" />
                        </div>
                          <h2 className="font-bold text-black text-t-16 px-3 pt-2">{item.EventName}</h2>
                          <h2 className="text-gray-1 text-t-14 px-3 pt-1">{item.EventLocation}</h2>
                          <p className="text-gray-1 text-t-14 px-3 pt-1">{item.EventDescription}</p>
                          <div className="flex justify-center items-center h-24">
                              <Link to={"/galllery"} className='rounded-lg bg-green-bg text-t-12 text-white py-1.5 px-3 items-center' onClick={()=>setEventId(item.EventId)}>More Details</Link>
                          </div>
                      </div>
                  ))}
                </div>
            </div>
        </div>
  </div>;
};

export default Events;